export default __webpack_public_path__ + "static/media/elle11.f53d4001.webp";